import { MSFilterLabelSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/label";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { SHStack } from "@components/design-systems";
import { useTheme } from "@mui/material";

export const MSFilterSwitchYesNoSkeleton = () => {
  const { palette, shadows } = useTheme();

  return (
    <SHStack
      padding={1.5}
      bgcolor={palette.common.white}
      borderRadius={"12px"}
      boxShadow={shadows[1]}
      gap={1.5}
    >
      <MSFilterLabelSkeleton />

      <SHStack direction="row" gap={1}>
        {Array.from({ length: 3 }).map((_, i) => (
          <SHSkeleton
            key={i}
            width={"33%"}
            height={35}
            delay={false}
            sx={{ borderRadius: "50px" }}
          />
        ))}
      </SHStack>

      <MSFilterLabelSkeleton showIcon={false} />
      <SHSkeleton width={"100%"} height={40} delay={false} />
    </SHStack>
  );
};
